export function getConfigurl():string{
    // Check if the environment variable is set, otherwise use the default URL
    return process.env.REACT_APP_CONFIG_URL || 'https://rheoport-api.azurewebsites.net'
}

export function getRheoApiUrl():string{
    // Check if the environment variable is set, otherwise use the default URL
    return process.env.REACT_APP_RHEO_SERVER_URL || 'https://rheo-api.azurewebsites.net'
}

export function getRheoApiWebsocketUrl():string{
    // Check if the environment variable is set, otherwise use the default URL
    return process.env.REACT_APP_RHEO_SERVER_WEBSOCKET_URL || 'wss://rheo-api.azurewebsites.net'
}

export function buildConfigURL(path:string):URL{
    const configURL = getConfigurl()
    return new URL(configURL+path)
}

export function buildRheoURL(path:string):URL{
    const rheoURL = getRheoApiUrl()
    return new URL(rheoURL+path)
}
export function getSkidsWithConfigHeadersEndpoint():string{
     return process.env.REACT_APP_Skids_endpoint || "/GetUserSkidsWithHeaders"
}
export function getRheoServerUrl():string{
    return process.env.REACT_APP_RHEO_SERVER_URL || 'https://rheoserver.wittystone-a146b357.norwayeast.azurecontainerapps.io'
}